import { FETCH_TOPOLOGY_SUCCESS } from './topology-actions';

export default function topology(state = {}, action) {
  switch (action.type) {
    case FETCH_TOPOLOGY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
